module.exports = __webpack_public_path__ + "static/media/hall-CSA.93d80f49.svg";